"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdtfWriteableBufferView = void 0;
const SdtfBaseWriteableComponent_1 = require("./SdtfBaseWriteableComponent");
const SdtfWriteableBuffer_1 = require("./SdtfWriteableBuffer");
class SdtfWriteableBufferView extends SdtfBaseWriteableComponent_1.SdtfBaseWriteableComponent {
    constructor() {
        super(...arguments);
        this.additionalProperties = {};
    }
    static clone(orig) {
        const clone = new SdtfWriteableBufferView();
        if (orig.buffer)
            clone.buffer = SdtfWriteableBuffer_1.SdtfWriteableBuffer.clone(orig.buffer);
        clone.byteLength = orig.byteLength;
        clone.byteOffset = orig.byteOffset;
        clone.contentEncoding = orig.contentEncoding;
        clone.contentType = orig.contentType;
        clone.name = orig.name;
        clone.additionalProperties = Object.assign({}, orig.additionalProperties);
        return clone;
    }
}
exports.SdtfWriteableBufferView = SdtfWriteableBufferView;
//# sourceMappingURL=SdtfWriteableBufferView.js.map